import React from "react";
import { connect } from "react-redux";

import DataGrid, {
  Column,
  LoadPanel,
  Scrolling,
  FilterRow,
  Selection
} from "devextreme-react/data-grid";
import OutsideClickHandler from "react-outside-click-handler";
import CachedIcon from "@material-ui/icons/Cached";
import { withStyles } from "@material-ui/core/styles";
import { columns } from "./utils";
import AddButton from "../../../../../ui/AddButton";
import DeleteButton from "../../../../../ui/DeleteButton";
import Box from "../../../../../ui/Box";
import AddRoomTypeModal from "./components/AddRoomTypeModal";
import UpdateRoomTypeModal from "./components/UpdateRoomTypeModal";
import DeleteConfirmationModal from "../../../../../ui/DeleteConfirmationModal";
import { deleteRoomTypes } from "../store/deleteactions";

const styles = {
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
  controls: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "16px",
    "& > div": {
      display: "flex",
      alignItems: "flex-end",
      "& > *:not(:nth-last-child(1))": {
        marginRight: "14px"
      }
    }
  }
};

class RoomTypeTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      selectedRoomTypes: [],
      deleteConfimationOpen: false,
      addRoomTypeOpen: false,
      updateRoomTypeOpen:false,
      focusedRoomType: -1,
      focusedRowTypeIndex: -1
    };

    this.selectRoomTypes = this.selectRoomTypes.bind(this);
    this.deleteRoomTypes = this.deleteRoomTypes.bind(this);
    this.searchByText = this.searchByText.bind(this);
    this.triggerColumnChooser = this.triggerColumnChooser.bind(this);
    this.showDeleteModal = this.showDeleteModal.bind(this);
    this.showAddModal = this.showAddModal.bind(this);
    this.onRowClick = this.onRowClick.bind(this);

    this.dataGridRef = React.createRef();
  }

  selectRoomTypes({ selectedRowsData }) {
    this.setState({ selectedRoomTypes: selectedRowsData });
  }

  deleteRoomTypes() {
    const { deleteRoomTypes } = this.props;
    const roomtypesIdList = this.state.selectedRoomTypes.map(({ id }) => id);

    deleteRoomTypes(roomtypesIdList);
  }

  triggerColumnChooser() {
    this.dataGridRef.current.instance.showColumnChooser();
  }

  searchByText(e) {
    const text = e.target.value;
    this.dataGridRef.current.instance.searchByText(text);
  }

  showDeleteModal() {
    this.setState({
      deleteConfimationOpen: !this.state.deleteConfimationOpen
    });
  }

  showAddModal() {
    this.setState({ addRoomTypeOpen: !this.state.addRoomTypeOpen });
  }

  onRowClick(e) {
    const focusedRoomType = e !== -1 ? e.data.id : e;
    const focusedRowIndex = e !== -1 ? e.rowIndex : e;
    this.setState({ focusedRoomType, focusedRowIndex });

    if (focusedRoomType !== -1){
      this.setState({ updateRoomTypeOpen: true });
    }
    else{
      this.setState({ updateRoomTypeOpen: false });
    }
  }

  render() {
    const {
      selectedRoomTypes,
      deleteConfimationOpen,
      addRoomTypeOpen,
      updateRoomTypeOpen,
      focusedRowIndex,
      focusedRoomType
    } = this.state;
    const {
      classes,
      roomtypes,
      getRoomTypes,
      //createRoomType,
    } = this.props;

    const { root, controls } = classes;

    return (
      <div className={root}>
        <Box>
          <DeleteConfirmationModal
            modalText="Удалить выбранные типы помещений?"
            open={deleteConfimationOpen}
            onConfirm={this.deleteRoomTypes}
            handleClose={this.showDeleteModal}
          />
          <AddRoomTypeModal
            open={addRoomTypeOpen}
            handleClose={() => this.setState({ addRoomTypeOpen: false })}
            /*createRoomType={createRoomType}
            isCreatingRoomType={roomTypesData.isCreatingRoomType}
            createdRoomType={roomTypesData.createdRoomType}*/
          />
          <UpdateRoomTypeModal
            open={updateRoomTypeOpen}
            handleClose={
              () => {this.setState({ updateRoomTypeOpen: false });
              this.onRowClick(-1);}
            }
            roomTypeId={focusedRoomType}
          />
          <div className={controls}>
            <div>
              Типы помещений
            </div>
            <div>
              <AddButton onClick={this.showAddModal}/>
              {selectedRoomTypes.length > 0 &&
              <DeleteButton onClick={this.showDeleteModal}/>}
            </div>
          </div>
          <div>
            <DataGrid
              elementAttr={{
                id: "gridContainer"
              }}
              dataSource={roomtypes}
              onSelectionChanged={this.selectRoomTypes}
              onRowClick={this.onRowClick}
              focusedRowIndex={focusedRowIndex}
              ref={this.dataGridRef}
              wordWrapEnabled={true}
              focusedRowEnabled
              errorRowEnabled={false}
              showBorders
            >
              <Selection
                mode="multiple"
                showCheckBoxesMode="onClick"
                showBorders={true}
                width={120}
              />
              {columns.map(column => (
                <Column key={column.dataField} {...column} />
              ))}
              <FilterRow visible={true} />
              <Scrolling mode="virtual" />
              <LoadPanel enabled />
            </DataGrid>
          </div>
        </Box>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isDeletingRoomTypes: state.nomenclature.isDeletingRoomTypes

});

const mapDispatchToProps = dispatch => ({
  deleteRoomTypes: (idList) => dispatch(deleteRoomTypes(idList))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(RoomTypeTable));
